import {Hash} from "../../../interfaces/hashInterfaces";
import {IRoleData, IRoleMetadata} from "../../../interfaces/roleInterfaces";
// these enum values need to match documentRoleCapability.ts
export enum PeerDocumentRoleCapability {
  viewAllLicenseHistories = 9,
  viewLicenseeHistory = 10,
  viewComplaints = 11,
  manageLicenseStatuses = 12,
  viewOnSubmissionsDashboard = 5,
  viewAllSubmissionDetails = 15,
  viewSubmissionDetailsAndExport = 7,
  inputExternalSubmissionData = 14,
  deleteSubmissions = 25,
  viewObjectModelRecordsOnSubmissionDashboard = 16,
  exportObjectModelRecordData = 17,
  viewAnalytic = 21,
  exportAnalyticData = 22,
}

export const PeerDocumentRoleMetadata: { [key in PeerDocumentRoleCapability]: IRoleMetadata } = {
  [PeerDocumentRoleCapability.viewAllLicenseHistories]: {
    label: 'View license histories',
  },
  [PeerDocumentRoleCapability.viewLicenseeHistory]: {
    label: 'View licensee history',
  },
  [PeerDocumentRoleCapability.viewComplaints]: {
    label: 'View complaints',
  },
  [PeerDocumentRoleCapability.manageLicenseStatuses]: {
    label: 'Manage license statuses',
  },
  [PeerDocumentRoleCapability.viewOnSubmissionsDashboard]: {
    label: 'View document on Reporting & Submissions dashboard',
  },
  [PeerDocumentRoleCapability.viewAllSubmissionDetails]: {
    label: 'View all submission details',
  },
  [PeerDocumentRoleCapability.viewSubmissionDetailsAndExport]: {
    label: 'View all submission details & export data',
  },
  [PeerDocumentRoleCapability.inputExternalSubmissionData]: {
    label: 'Input external data'
  },
  [PeerDocumentRoleCapability.deleteSubmissions]: {
    label: 'Delete submissions'
  },
  [PeerDocumentRoleCapability.viewObjectModelRecordsOnSubmissionDashboard]: {
    label: "View records on Reporting & Submissions"
  },
  [PeerDocumentRoleCapability.exportObjectModelRecordData]: {
    label: "Export Data"
  },
  [PeerDocumentRoleCapability.viewAnalytic]: {
    label: "View analytic"
  },
  [PeerDocumentRoleCapability.exportAnalyticData]: {
    label: "Export analytic data"
  },
};

export const PeerDocumentRoleData: Hash<Hash<IRoleData<PeerDocumentRoleCapability>[]>> = {
  'General Settings': {
    'Manage Licenses': [
      {
        label: PeerDocumentRoleMetadata[PeerDocumentRoleCapability.viewAllLicenseHistories].label,
        capability: PeerDocumentRoleCapability.viewAllLicenseHistories
      },
      {
        label: PeerDocumentRoleMetadata[PeerDocumentRoleCapability.viewLicenseeHistory].label,
        capability: PeerDocumentRoleCapability.viewLicenseeHistory
      },
      {
        label: PeerDocumentRoleMetadata[PeerDocumentRoleCapability.viewComplaints].label,
        capability: PeerDocumentRoleCapability.viewComplaints
      },
      {
        label: PeerDocumentRoleMetadata[PeerDocumentRoleCapability.manageLicenseStatuses].label,
        capability: PeerDocumentRoleCapability.manageLicenseStatuses
      },
    ],
    'Manage Submissions': [
      {
        label: PeerDocumentRoleMetadata[PeerDocumentRoleCapability.viewOnSubmissionsDashboard].label,
        capability: PeerDocumentRoleCapability.viewOnSubmissionsDashboard
      },
      {
        label: PeerDocumentRoleMetadata[PeerDocumentRoleCapability.viewAllSubmissionDetails].label,
        capability: PeerDocumentRoleCapability.viewAllSubmissionDetails
      },
      {
        label: PeerDocumentRoleMetadata[PeerDocumentRoleCapability.viewSubmissionDetailsAndExport].label,
        capability: PeerDocumentRoleCapability.viewSubmissionDetailsAndExport
      },
      {
        label: PeerDocumentRoleMetadata[PeerDocumentRoleCapability.inputExternalSubmissionData].label,
        capability: PeerDocumentRoleCapability.inputExternalSubmissionData
      },
      {
        label: PeerDocumentRoleMetadata[PeerDocumentRoleCapability.deleteSubmissions].label,
        capability: PeerDocumentRoleCapability.deleteSubmissions
      }
    ],
    'Manage Object Models': [
      {
        label: PeerDocumentRoleMetadata[PeerDocumentRoleCapability.viewObjectModelRecordsOnSubmissionDashboard].label,
        capability: PeerDocumentRoleCapability.viewObjectModelRecordsOnSubmissionDashboard
      },
      {
        label: PeerDocumentRoleMetadata[PeerDocumentRoleCapability.exportObjectModelRecordData].label,
        capability: PeerDocumentRoleCapability.exportObjectModelRecordData
      },
    ],
    'Manage Analytics': [
      {
        label: PeerDocumentRoleMetadata[PeerDocumentRoleCapability.viewAnalytic].label,
        capability: PeerDocumentRoleCapability.viewAnalytic
      },
      {
        label: PeerDocumentRoleMetadata[PeerDocumentRoleCapability.exportAnalyticData].label,
        capability: PeerDocumentRoleCapability.exportAnalyticData
      },
    ]
  }
};
